export const csvHeaders = [
    { label: 'Row ID', key: 'id' },
    { label: 'VPS', key: 'vps_ip' },
    { label: 'Steam ID', key: 'steam_account_id' },
    { label: 'Item Name', key: 'name' },
    { label: 'Item ID', key: 'steam_item_id' },
    { label: 'Buff Price (¥)', key: 'buff_price' },
    { label: 'Float', key: 'float_num' },
    { label: 'Pattern', key: 'pattern' },
    { label: 'True Price (¥)', key: 'price' },
    { label: 'Source In', key: 'source_in' },
    { label: 'Buy Price', key: 'buy_price' },
    { label: 'TBP', key: 'time_buy_price' },
    { label: 'Source Out', key: 'source_out' },
    { label: 'Sold Price', key: 'sold_price' },
    { label: 'Buy Date', key: 'buy_date' },
    { label: 'Sold Date', key: 'sold_date' },
    { label: 'Day Time', key: 'days_locked' },
    { label: 'Demand', key: 'demand' },
    { label: 'Status', key: 'status' },
    { label: 'CBP', key: 'convert_buy_price' },
    { label: 'CSP', key: 'convert_sold_price' },
    { label: 'Trend (%)', key: 'trend_price' },
    { label: 'Profit (%)', key: 'profit_percentage' },
    { label: 'Profit', key: 'profit' },
    { label: 'Wax Min Sell', key: 'wax_min_sale' },
    { label: 'Wax True Sell Point', key: 'wax_true_sell_point' },
    { label: 'Wax Time Sell Point', key: 'wax_time_sell_point' },
    { label: 'Wax Null Sell Point', key: 'wax_null_sell_point' },
    { label: 'Web Price', key: 'web_price' },
    { label: 'Updated At', key: 'updated_at' },
]

export const optionsStatus = [
    { value: 'uncheck', label: 'uncheck' },
    { value: 'active', label: 'active' },
    { value: 'inactive', label: 'inactive' },
    { value: 'sold', label: 'sold' },
]

export const optionsDemand = [
    { value: 'HighEtop', label: 'HighEtop' },
    { value: 'HighYp', label: 'HighYp' },
    { value: 'HighCsm', label: 'HighCsm' },
    { value: 'HighWax', label: 'HighWax' },
    { value: 'HardSell', label: 'HardSell' },
]

export const optionsSourceIn = [
    { value: 'ETOP', label: 'ETOP' },
    { value: 'CSM', label: 'CSM' },
    { value: 'YP', label: 'YP' },
    { value: 'BUFF', label: 'BUFF' },
    { value: 'TRADEIT', label: 'TRADEIT' },
    { value: 'SWAPGG', label: 'SWAPGG' },
    { value: 'LOOTFARM', label: 'LOOTFARM' },
    { value: 'CSTRADE', label: 'CSTRADE' },
    { value: 'SKINSCOM', label: 'SKINSCOM' },
    { value: 'CSFLOAT', label: 'CSFLOAT' },
    { value: 'SKILSWAP', label: 'SKILSWAP' }
]

export const optionsSourceOut = [
    { value: 'ETOP', label: 'ETOP' },
    { value: 'CSM', label: 'CSM' },
    { value: 'YP', label: 'YP' },
    { value: 'WAX', label: 'WAX' },
    { value: 'TRADEIT', label: 'TRADEIT' },
    { value: 'SWAPGG', label: 'SWAPGG' },
    { value: 'LOOTFARM', label: 'LOOTFARM' },
    { value: 'CSTRADE', label: 'CSTRADE' },
    { value: 'SKINSCOM', label: 'SKINSCOM' },
    { value: 'CSFLOAT', label: 'CSFLOAT' },
    { value: 'SKILSWAP', label: 'SKILSWAP' }
]

export const optionsVPS = [
    { value: '45.117.177.249', label: '45.117.177.249' },
    { value: '103.124.92.110', label: '103.124.92.110' },
    { value: '103.179.190.110', label: '103.179.190.110' },
    { value: '103.170.122.115', label: '103.170.122.115' },
]

export const optionsWaxType = [
    { value: 'auto', label: 'auto' },
    { value: 'manual', label: 'manual' },
    { value: 'off', label: 'off' },
]

export const optionsIsWebType = [
    { value: true, label: 'On' },
    { value: false, label: 'Off' },
]

export const optionsUpdateType = [
    { value: 'auto', label: 'auto' },
    { value: 'manual', label: 'manual' },
]

export const optionsIsWebPopular = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
]

export const optionsIsWebBuying = [
    { value: true, label: 'Yes' },
    { value: false, label: 'No' },
]

export const optionsSteamID = [
    { value: '76561199683125609', label: '76561199683125609' },
    { value: '76561199514425351', label: '76561199514425351' },
    { value: '76561199439483680', label: '76561199439483680' },
    { value: '76561199514950931', label: '76561199514950931' },
    { value: '76561198770415230', label: '76561198770415230' },
]
